module.exports = __webpack_public_path__ + "img/ring_g_skip_0_null.3095d442.png";